// Format an entity type (property/loan/person/company) for display: split
// camelCase into separate words and Title-Case them, e.g. "betterProperty" =>
// "Better Property". Kept in its own dependency-free module (no app/date-fns/
// angular imports) so it can be unit-tested directly with `require`. Use a
// `*TypeLabel` override in the custom mapping when an exact label (acronyms,
// custom casing) is needed instead.
const titleCaseWords = (s) =>
  (s || "")
    .toLowerCase()
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

module.exports = (input) => titleCaseWords((input || "").replace(/([a-z\d])([A-Z])/g, "$1 $2"));
